<template>
  <div class="animated fadeIn form-mutasi">
    <b-card>
      <div slot="header">
        {{$route.meta.label}}
        <div class="card-header-actions">
          <button v-if="saveEnabled" class="btn btn-primary mr-1" @click.stop="save()">
            <i class="fa fa-save"></i> Save
          </button>
          <b-button class="btn btn-danger mr-1" @click="close()">
            <i class="fa fa-close"></i> Close
          </b-button>
        </div>
      </div>
        <b-row>
          <b-col lg="8">
            <b-input-group>
              <b-input-group-prepend>
                <label>Kode Pelanggan</label>
              </b-input-group-prepend>
              <b-form-input
                readonly
                v-model="model.CustInfo"
                @keyup.13.native="lkuKoranCustShow=true"
                :state="!$v.model.customer_id.$error"
              ></b-form-input>
              <b-input-group-append v-if="!(model.mutasiKey)" >
                <b-btn text="Button" id="btnKoranCust" @click="lkuKoranCustShow=true">
                  <i class="fa fa-search"></i>
                </b-btn>
              </b-input-group-append>
            </b-input-group>
            <b-input-group>
              <b-input-group-prepend>
                <label>Alamat Pengiriman</label>
              </b-input-group-prepend>
              <b-form-textarea v-model="model.DeliveryAddr" disabled rows="2" max-rows="5"></b-form-textarea>
            </b-input-group>
            <b-input-group>
              <b-input-group-prepend>
                <label>Telepon</label>
              </b-input-group-prepend>
              <b-form-input v-model="model.PhoneNo" readonly></b-form-input>
              <b-input-group-prepend>
                <span class="pl-2 pt-2">Titik Drop</span>
              </b-input-group-prepend>
              <b-form-input v-model="model.titikdrop" placeholder="Drop point" readonly></b-form-input>
            </b-input-group>
            <b-input-group>
              <b-input-group-prepend>
                <label>Sales/AE</label>
              </b-input-group-prepend>
              <input
                v-model="model.salesae_name"
                type="text"
                class="form-control"
                readonly
              />
              <b-input-group-prepend>
                <span class="pl-2 pt-2">Tipe Kiriman</span>
              </b-input-group-prepend>
              <input
                v-model="model.kiriman_name"
                type="text"
                placeholder="Tipe kiriman"
                class="form-control"
                readonly
              />
            </b-input-group>

          <div class="mb-4">
            <p class="text-center font-weight-bolder" style="width:100%;">Pola Kiriman  <span v-if="(model.gratis==1)" style="background-color:gold;">&nbsp; GRATIS &nbsp;</span> </p>
            <table class="table table-bordered">
              <thead>
                <tr>
                  <th style="width:80px;text-align:center;padding:0;">Senin</th>
                  <th style="width:80px;text-align:center;padding:0;">Selasa</th>
                  <th style="width:80px;text-align:center;padding:0;">Rabu</th>
                  <th style="width:80px;text-align:center;padding:0;">Kamis</th>
                  <th style="width:80px;text-align:center;padding:0;">Jumat</th>
                  <th style="width:80px;text-align:center;padding:0;">Sabtu</th>
                  <th style="width:80px;text-align:center;padding:0;">Minggu</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style="text-align:center;padding:0;">
                    <b-row no-gutters>
                      <b-col>{{model.seninEcer}}</b-col>
                    </b-row>
                  </td>
                  <td style="text-align:center;padding:0;">
                    <b-row no-gutters>
                      <b-col>{{model.selasaEcer}}</b-col>
                    </b-row>
                  </td>
                  <td style="text-align:center;padding:0;">
                    <b-row no-gutters>
                      <b-col>{{model.rabuEcer}}</b-col>
                    </b-row>
                  </td>
                  <td style="text-align:center;padding:0;">
                    <b-row no-gutters>
                      <b-col>{{model.kamisEcer}}</b-col>
                    </b-row>
                  </td>
                  <td style="text-align:center;padding:0;">
                    <b-row no-gutters>
                      <b-col>{{model.jumatEcer}}</b-col>
                    </b-row>
                  </td>
                  <td style="text-align:center;padding:0;">
                    <b-row no-gutters>
                      <b-col>{{model.sabtuEcer}}</b-col>
                    </b-row>
                  </td>
                  <td style="text-align:center;padding:0;">
                    <b-row no-gutters>
                      <b-col>{{model.mingguEcer}}</b-col>
                    </b-row>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

            <b-input-group>
              <b-input-group-prepend>
                <label>Tgl. Dibuat Mutasi</label>
              </b-input-group-prepend>
              <b-input-group-append>
                <span
                  class="input-group-text"
                  style="width:100px;"
                >{{model.createdate | ambilNamaHari}}</span>
              </b-input-group-append>
              <b-input
                type="datetime-local"
                v-model="model.createdate"
                :state="!$v.model.createdate.$error"
              ></b-input>
            </b-input-group>
            <b-input-group>
              <b-input-group-prepend>
                <label>Tgl. Efektif Mutasi</label>
              </b-input-group-prepend>
              <b-input-group-append>
                <span class="input-group-text" style="width:100px;">{{model.tanggal | ambilNamaHari}}</span>
              </b-input-group-append>
              <b-input
                type="date"
                v-model="model.tanggal"
                :state="!$v.model.tanggal.$error"
                :min="tglmutasi"
                @change="changeTglEfektif()"
                @input="changeTglEfektif()"
              ></b-input>
            </b-input-group>
            <b-input-group>
              <b-input-group-prepend>
                <label>Berlaku Mutasi</label>
              </b-input-group-prepend>
              <b-form-select
                v-model="model.onlyToday"
                v-bind:disabled="isSelectedTanggal"
                :state="!$v.model.onlyToday.$error"
                @input="changeMsBerlakuMutasi"
                :plain="!isSelectedTanggal"
              >
                <template v-slot:first>
                  <option :value="null" disabled>-- Pilih masa berlaku mutasi --</option>
                </template>
                <option value="1">Berlaku hanya tanggal {{model.tanggal}}</option>
                <option value="0">Berlaku seterusnya mulai {{model.tanggal}}</option>
              </b-form-select>
            </b-input-group>
            <b-input-group
              v-if="model.onlyToday =='0'"
              label-cols-md="3"
              class="mt-1"
              label="Pilihan Hari"
            >
              <b-input-group-prepend>
                <label>Pilih Hari</label>
              </b-input-group-prepend>
              <b-form-checkbox-group
                v-model="selectedDateDay"
                :options="effdtoptions"
              ></b-form-checkbox-group>
            </b-input-group>

            <b-input-group>
              <b-input-group-prepend>
                <label>Jumlah Mutasi</label>
              </b-input-group-prepend>
              <b-form-input v-model="model.agen_eceran" type="number"  v-b-tooltip.hover :title="`${model.agen_eceran} eksemplar`" ></b-form-input>  
              <b-input-group-append><span class="input-group-text">Eks. (isi dg Jml.Akhir yg diinginkan!)</span></b-input-group-append>
              <b-input-group-prepend><label class="text-right">Konsinyasi</label></b-input-group-prepend>
              <b-form-input v-model="model.max_retur" readonly ></b-form-input>  
              <b-input-group-append><span class="input-group-text">%</span></b-input-group-append>
              <b-form-input :value="totKonsi | numFormat"readonly ></b-form-input>  
              <b-input-group-append><span class="input-group-text">Eks.</span></b-input-group-append>
            </b-input-group>


            <b-input-group>
              <b-input-group-prepend>
                <label>Alasan Mutasi</label>
              </b-input-group-prepend>
              <b-form-input
                v-model="model.uraian"
                placeholder="Alasan Mutasi"
              ></b-form-input>
            </b-input-group>
            <!-- <div class="float-right">
              <b-input-group class="text-center" v-if="canVwKiriman">
                <b-button @click="lkuKoranKirimanMutasi=true">Lihat Daftar Kiriman</b-button>
              </b-input-group>
            </div> -->
          </b-col>
        <b-col lg="4">
          <h5> Daftar Kirim sudah diGenerate</h5> 
          <b-table
            class="mb-0"
            ref="tblKiriman"
            responsive
            striped
            hover
            small
            style="font-size:smaller;"
            :items="dafKir.list"
            :fields="dafKir.fields"
            :current-page="dafKir.page"
            :per-page="dafKir.perpage"
            :sort-by.sync="dafKir.sortBy"
            :sort-desc.sync="dafKir.sortDesc"
            :busy="isBusyDataKiriman"
          >
            <template v-slot:table-busy>
              <div class="text-center text-danger my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>Sedang mengunduh data...</strong>
              </div>
            </template>

              <template v-slot:cell(tanggal)="data">
                  {{data.item.tanggal | ambilNamaHari}}, {{ data.item.tanggal | moment("DD MMM YYYY") }} 
              </template>
          </b-table>
          <b-row>
            <b-col cols="6">
              <div>
                {{(dafKir.page - 1) * dafKir.perpage + 1}}
                to
                {{dafKir.page * dafKir.perpage}}
                of
                {{dafKir.total}}
              </div>
            </b-col>
            <b-col cols="6">
              <b-pagination
                align="right"
                :total-rows="dafKir.total"
                :per-page="dafKir.perpage"
                v-model="dafKir.page"
              ></b-pagination>
            </b-col>
          </b-row>
        </b-col>
            <!-- <button v-if="saveEnabled" class="btn btn-primary mr-1" @click.stop="save()">
              <i class="fa fa-save"></i> Save
            </button>
            <b-button class="btn btn-primary mr-1" @click.stop="close()">
              <i class="fa fa-close"></i> Close
            </b-button> -->
      </b-row>
    </b-card>

    <b-modal
      v-model="lkuKoranCustShow"
      size="lg"
      :hide-footer="true"
      title="Daftar Customer Boleh Mutasi"
      :centered="true"
    >
      <lku-koran-polaharga @click="onSelectKoranCust" ></lku-koran-polaharga>
    </b-modal>

  </div>
</template>

<style lang="scss">
  .form-mutasi {
      table.b-table[aria-busy="true"] {
        opacity: 0.6;
      }

  }
</style>

<script>
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import toastr from "mini-toastr";
import vNumber from "vue-numeric";
import koran_mutasi_psn from "../../apis/koran_mutasi_pesanan";
import lkuKoranPolaharga from "../lookup/lkuKoranPolaHarga";

import moment from "moment";
toastr.init();

export default {
  components: { lkuKoranPolaharga, vNumber },
  mixins: [validationMixin],
  validations: {
    model: {
      customer_id: { required },
      tanggal: { required },
      onlyToday: { required },
      agen_eceran: { required },
      hrg_agen_ecer: { required },
      createdate: { required },
      // uraian: { required }
    }
  },
  data() {
    return {
      items: [],
      saveEnabled: true,
      lkuKoranCustShow: false,
      selectedDateDay: [],      
      minDate: moment(this.$store.state.user.tglkoran),
      tglmutasi: moment().format("YYYY-MM-DD"),
      model: {
        customer_id: "",pascabayarkey:'', gratis:0, 
        tanggal: null,
        uraian:'',
        onlyToday: null,
        agen_eceran: 0,
        seninOk: 0,
        selasaOk: 0,
        rabuOk: 0,
        kamisOk: 0,
        jumatOk: 0,
        sabtuOk: 0,
        mingguOk: 0,
        createdate: moment().format("YYYY-MM-DDTHH:mm"),
        kiriman_code: null,
        jurusan_id: null,
        salesae_id: null,
        kota_id: null,
        collector_id: null,
        tglbuka: null,
        tgltutup: null,
        isactive: 1,
        seninEcer: 0,
        seninEcerMutasi: 0,
        selasaEcer: 0,
        selasaEcerMutasi: 0,
        rabuEcer: 0,
        rabuEcerMutasi: 0,
        kamisEcer: 0,
        kamisEcerMutasi: 0,
        jumatEcer: 0,
        jumatEcerMutasi: 0,
        sabtuEcer: 0,
        sabtuEcerMutasi: 0,
        mingguEcer: 0,
        mingguEcerMutasi: 0,
      },
      detail:{},
      mutasi: {
        seninTotal: 0,
        selasaTotal: 0,
        rabuTotal: 0,
        kamisTotal: 0,
        jumatTotal: 0,
        sabtuTotal: 0,
        mingguTotal: 0
      },
      isBusyDataKiriman: false,
      allDay: true,
      effdtoptions: [
        { text: "Senin", value: "seninOk" },
        { text: "Selasa", value: "selasaOk" },
        { text: "Rabu", value: "rabuOk" },
        { text: "Kamis", value: "kamisOk" },
        { text: "Jum'at", value: "jumatOk" },
        { text: "Sabtu", value: "sabtuOk" },
        { text: "MInggu", value: "mingguOk" }
      ],
      keysNameDays: [
        "seninOk",
        "selasaOk",
        "rabuOk",
        "kamisOk",
        "jumatOk",
        "sabtuOk",
        "mingguOk"
      ],
      tblData: {
        items: [],
        page: 1,
        limit: 15,
        total: 0,
        sortBy: null,
        sortDesc: false,
        koran: "1"
      },
      dafKir: {
        page: 1,
        perpage: 10,
        limit: 200,
        total: 0,
        sortBy: 'tanggal',
        sortDesc: false,
        list:'',
        fields:[
        {
          key: "tanggal",
          label: "Tgl.Kirim",
        },
        {
          key: "totpaid",
          label: "Ber Bayar",
          thClass: "text-center",
          tdClass: "text-center"
        },
        {
          key: "Gratis",
          label: "Tdk Bayar",
          thClass: "text-center",
          tdClass: "text-center"
        },
        {
          key: "totkirim",
          label: "Total Kirim",
          thClass: "text-center",
          tdClass: "text-center"
        }
        ]
      },

    };
  },
  computed: {
    totKonsi() {
      return Math.floor(parseInt(this.model.agen_eceran)*parseInt(this.model.max_retur)/100);
    },
    isReqSelectDay() {
      if (this.model.onlyToday) return false;
      if (!this.model.onlyToday && this.selectedDateDay.length > 0) {
        return false;
      } else {
        return true;
      }
    },
    invalidModel() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },

    isSelectedTanggal() {
      if (this.model.tanggal) {
        return false;
      } else {
        return true;
      }
    },
    // onChSelectedDateDay() {
    //   return this.selectedDateDay;
    // }
  },
  // watch: {
  //   onChSelectedDateDay(val) {
  //     this.changeMutasi(val);
  //   },
  filters: {
    ambilNamaHari(tanggal) {
      const namesDay = [
        "Minggu",
        "Senin",
        "Selasa",
        "Rabu",
        "Kamis",
        "Jumat",
        "Sabtu"
      ];
      const day_ = namesDay[moment(tanggal).day()];
      return day_;
    }
  },
  created: async function() {
    if (this.$route.params.mutasiKey) {
      const detail = await koran_mutasi_psn.detail(this.$route.params);
        if (detail) {
            for (var key in detail) {
              this.model[key]=detail[key];
            }
        }
        this.model.tanggal = moment(detail.tanggal).format('YYYY-MM-DD');
        this.model.createdate = moment(detail.createdate).format("YYYY-MM-DDTHH:mm");
        this.tglmutasi = this.model.createdate;      

      // this.model.createdate = moment(detail.createdate).format("YYYY-MM-DDTkk:mm");
      this.model.selected = [];
      const keys = this.keysNameDays;
      for (const iterator of keys) {
        if (this.model[iterator] === 1) {
          this.selectedDateDay.push(iterator);
        }
      }
      this.ambilDaftkir();

    // this.$watch('onChSelectedDateDay', function(val) {
        // setTimeout(() => {
            // this.changeMutasi(val);
        // }, 100);
    // });        
        this.$forceUpdate();                
    }
    this.$watch('model.createdate', function(newVal) {
        setTimeout(() => {
            if (moment(newVal)<this.minDate) {
                toastr.error('Transaksi Tanggal Tersebut sudah di Closing','ERROR MESSAGE',10000);
                this.model.createdate=this.minDate.format("YYYY-MM-DDTHH:mm");
                if (moment(this.model.tanggal).format('YYYY-MM-DD')<this.minDate.format('YYYY-MM-DD')) {
                  this.model.tanggal=this.this.minDate.format('YYYY-MM-DD');
                }
            } else {
              this.tglmutasi = moment(newVal).format('YYYY-MM-DD');      
              if (moment(this.model.tanggal).format('YYYY-MM-DD')<this.tglmutasi) {
                this.model.tanggal=this.tglmutasi;
                toastr.warn('Tanggal Efektif mutasi tidak valid','WARNING MESSAGE',10000);
              }
            }
            this.$forceUpdate();
        }, 50);
    });            

  },
  methods: {
    onSelectKoranCust: async function(_selected) {
        this.lkuKoranCustShow = false;
        for (var key in _selected) {
          this.model[key]=_selected[key];
        }
        this.model.CustInfo = _selected.CustCode+ ' | '+_selected.CustName;
        console.log('pascabayarkey : ', this.model.pascabayarkey);
        // this.model.customer_id = _selected.customer_id;
        // this.model.CustName = _selected.CustName;
        // this.model.CustCode = _selected.CustCode;
        // this.model.DeliveryAddr = _selected.DeliveryAddr;
        // this.model.PhoneNo = _selected.PhoneNo;
        // const [detail] = await koran_pesanan_pascabayar.detail({customer_id: _selected.customer_id});
        //   for (var key in detail) {
        //     this.model[key]=detail[key];
        //     console.log (key,this.model[key]);
        //   }

        this.$forceUpdate();                
    },
    changeTglEfektif() {
      this.model.onlyToday = null;
      this.model.selected = [];
      this.dafKir.list = [];
      if (moment(this.model.tanggal)<this.minDate) {
          toastr.error('Transaksi Tanggal Tersebut sudah di Closing','ERROR MESSAGE',10000);
          this.model.tanggal=this.this.minDate.format('YYYY-MM-DD');
      }      
        setTimeout(() => {
            this.ambilDaftkir();
        }, 200);      
    },
    // ini untuk masa berlaku mutasi
    changeMsBerlakuMutasi() {
      if (this.model.onlyToday === "1") {
        const namesDay = [
          "minggu",
          "senin",
          "selasa",
          "rabu",
          "kamis",
          "jumat",
          "sabtu"
        ];
        const day_ = namesDay[moment(this.model.tanggal).day()];
        const selectedDateDay = [`${day_}Ok`];
        this.selectedDateDay = selectedDateDay;
      // } else {
        // this.selectedDateDay = this.keysNameDays;
      }
    },
    ambilDaftkir: async function() {
      if ((this.model.customer_id) || (this.model.tanggal) || (this.model.kiriman_code)) {
          this.isBusyDataKiriman=true;
          this.dafKir.customer_id=this.model.customer_id;
          this.dafKir.customer_group= this.model.kiriman_code;
          this.dafKir.tgl1=this.model.tanggal;
          // this.dafKir.list = await koran_mutasi_psn.listKiriman(this.dafKir);
          // this.isBusyDataKiriman=false;
          koran_mutasi_psn.listKiriman(this.dafKir).then(result => {
                  this.dafKir.list = result;
                  this.isBusyDataKiriman=false;
              })
              .catch(err => {
                  console.log('ambilDaftkir -> ', err);                  
              });
      }
    },
    save: async function() {
      if (this.invalidModel || this.isReqSelectDay) {
        toastr.error("Please fill the form correctly.", "ERROR MESSAGE");
      } else {
        try {
          const keys = this.keysNameDays;
          for (const iterator of keys) {
            this.model[iterator] = 0;
          }
          for (const iterator of this.selectedDateDay) {
            this.model[iterator] = 1;
          }
          const data = JSON.parse(JSON.stringify(this.model));
        data.tanggal = moment(this.model.tanggal).format('YYYY-MM-DD');
        data.createdate = moment(this.model.createdate).format('YYYY-MM-DD HH:mm');

          await koran_mutasi_psn.save(data);
          toastr.success("Save successfully");
          this.close();
        } catch (error) {
          if (error.message) {
            toastr.error(error.message, "ERROR MESSAGE", 10000);
          } else {
            toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
          }
        }
      }
    },
    close() {
      router.push({ name: "koran.mutasipesanan" });
    }
  }
};
</script>